import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserListItem from './UserListItem'
import Ink from 'react-ink';
import * as resource from '../constants/Resources'
import { getTranslation } from '../actions/dataActions'
import PropTypes from 'prop-types'

class UserList extends Component {
  constructor(props) {
    super(props);
    this.handleUserListItem = this.handleUserListItem.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.state = {
      page: 0
    }
  }

  handleUserListItem(props) {
    this.props.onClick(props)
  }
  previousPage() {
    const currentPage = this.state.page;
    if (currentPage - 1 >= 0) {
      this.setState({
        page: currentPage - 1
      });
    }
  }
  nextPage() {
    const currentPage = this.state.page;
    if ((currentPage + 1) * 10 <= this.props.users.length) {
      this.setState({
        page: currentPage + 1
      });
    }
  }

  render() {
    const fromUser = 10 * this.state.page;
    const toUser = 10 * (this.state.page + 1);

    const users = [];
    for (let i = fromUser; i < toUser; i++) {
      if (this.props.users.length > i) {
        users.push({
          Key: i,
          UserId: this.props.users[i].SystemUserId,
          UserName: this.props.users[i].UserName
        });
      } else {
        users.push({
          Key: i,
          SystemUserId: 0,
          UserName: ''
        })
      }
    }
    return (
       <div className="userlist" style={{ display: this.props.visibility }}>
        <div className="userlistheader">
        {this.props.getTranslation(resource.CHOOSE_USER)}
        </div>
        {
            users.map(user =>
              <UserListItem
                key={user.Key}
                UserName={user.UserName}
                SystemUserId={user.UserId}
                onClick={this.handleUserListItem}
              />
            )
        }
        <button className="userlistnav" onClick={this.previousPage}>
          <i className="caret left icon"></i>
          <Ink />
        </button>
        <button className="userlistnav" onClick={this.nextPage}>
          <i className="caret right icon"></i>
          <Ink />
        </button>
       </div>

      )
  }
}
UserList.propTypes = {
  users: PropTypes.array.isRequired,
  visibility: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}
function mapStateToProps(state) {
  return {
    users: state.loginState.users
  }
}

export default connect(mapStateToProps, { getTranslation })(UserList);



// WEBPACK FOOTER //
// src/login/UserList.jsx